// extracted by mini-css-extract-plugin
export default {"menu":"menu-0bba","isOpen":"isOpen-d685","maxHeightSmallMenu":"maxHeightSmallMenu-a301"};